(function() {
  var Service,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.IrrigationDetails = (function(superClass) {
    extend(IrrigationDetails, superClass);

    function IrrigationDetails(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      void 0;
    }

    IrrigationDetails.prototype.getMethods = function() {
      return this.http.post('backend/grower/layers/management-zones/get-irrigation-methods');
    };

    IrrigationDetails.prototype.getWaterSources = function() {
      return this.http.get('backend/grower/layers/management-zones/water-sources');
    };

    IrrigationDetails.prototype.getSources = function() {
      return this.http.post("backend/grower/layers/management-zones/get-energy-sources");
    };

    IrrigationDetails.prototype.save = function(details) {
      return this.http.post("backend/grower/layers/management-zones/save-details", {
        details: details
      });
    };

    IrrigationDetails.prototype.load = function(layer) {
      return this.http.post("backend/grower/layers/management-zones/" + layer + "/load-details");
    };

    return IrrigationDetails;

  })(Service);

}).call(this);
